import { render, staticRenderFns } from "./CCharacterCounter.vue?vue&type=template&id=075aa462&scoped=true&"
import script from "./CCharacterCounter.vue?vue&type=script&lang=ts&"
export * from "./CCharacterCounter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075aa462",
  null
  
)

export default component.exports